import useFormState, { createFormValidation } from "use-form-state";
import { addDays, getEndOfDay, getUtcDateTime } from "../../../util/dates";

const toDateInputValue = (date) =>
  new Date(date).toISOString().split("T")[0];

const INITIAL_VALUES = {
  expirationDate: toDateInputValue(addDays(Date.now(), 30)),
};

const validation = createFormValidation([
  {
    path: "expirationDate",
    validate: (date) =>
      date && new Date(date) >= new Date().setHours(0, 0, 0, 0),
    message: "Selected date cannot be in the past",
  },
]);

const toCreateImpersonationRightInput = ({ expirationDate }) => ({
  expirationDateTime: getUtcDateTime(
    getEndOfDay(new Date(expirationDate))
  ),
});

const useImpersonationForm = (options) =>
  useFormState(INITIAL_VALUES, {
    validation,
    valuesToInput: toCreateImpersonationRightInput,
    ...options,
  });

export default useImpersonationForm;
